import { ReactNode } from "react";

import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material";

import { getStyles } from "../sidebar.helpers";

interface SectionHeaderProps {
  open: boolean;
  canNavigate: boolean;
  isExpanded: boolean;
  toggleExpand: () => void;
  label: string;
  onClick: () => void;
  icon: ReactNode;
  showToggle: boolean;
}

function SectionHeader({ open, canNavigate, isExpanded, toggleExpand, label, onClick, icon, showToggle }: SectionHeaderProps) {
  const theme = useTheme();

  return (
    <ListItem
      secondaryAction={
        showToggle ? (
          <IconButton edge='end' aria-label={isExpanded ? "Collapse" : "Expand"} onClick={toggleExpand}>
            {isExpanded ? <ExpandLess sx={getStyles(theme).icon} /> : <ExpandMore sx={getStyles(theme).icon} />}
          </IconButton>
        ) : undefined
      }
    >
      <ListItemButton sx={getStyles(theme).listItemButton(open, true)} disabled={!canNavigate} onClick={onClick} aria-expanded={isExpanded}>
        <ListItemIcon sx={getStyles(theme).listItemIcon(open)}>{icon}</ListItemIcon>
        <ListItemText
          primaryTypographyProps={getStyles(theme).listItemPrimaryTypographyProps}
          primary={label}
          sx={getStyles(theme).listItemText(open)}
        />
      </ListItemButton>
    </ListItem>
  );
}

export default SectionHeader;
